export default {"src":"/_next/static/media/world_icon.7e9be524.svg","height":32,"width":32};